import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/platform/components/AuthShell";
import { Button, TextField } from "@/platform/components/primitives";
import { api } from "@/platform/api";
import { useAuth } from "@/platform/AuthContext";

const GENERIC = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com", "proton.me", "protonmail.com", "aol.com", "live.com"];

function suggestName(user) {
  const email = user?.email || "";
  const domain = (email.split("@")[1] || "").toLowerCase();
  if (domain && !GENERIC.includes(domain)) {
    const base = domain.split(".")[0];
    return base.charAt(0).toUpperCase() + base.slice(1);
  }
  const first = (user?.fullName || "").trim().split(" ")[0];
  return first ? `${first}'s Workspace` : "My Workspace";
}

export default function Workspace() {
  const navigate = useNavigate();
  const { user, setWorkspace } = useAuth();
  const [name, setName] = useState(useMemo(() => suggestName(user), [user]));
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!name.trim()) { setError("Please name your workspace."); return; }
    setError("");
    setLoading(true);
    try {
      const ws = await api.post("/api/workspaces", { name: name.trim() });
      setWorkspace(ws);
      navigate("/app", { replace: true });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="animate-in fade-in duration-500">
        <h1 className="text-[26px] font-semibold tracking-tight text-[#F4F5F8]">Name your workspace</h1>
        <p className="mt-2 text-[15px] text-[#98A0B0]">Your workspace is where your team and projects will live.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="workspace-form">
          <TextField
            id="workspace"
            label="Workspace name"
            placeholder="Sunday Digital"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={error}
            autoFocus
            data-testid="workspace-name"
          />
          <Button type="submit" loading={loading} data-testid="workspace-submit">Create workspace</Button>
        </form>
      </div>
    </AuthShell>
  );
}
